var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"size":100,"width":4,"color":"teal","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }